import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { Alert, Flex, Form, Radio } from 'antd';
import { AccountType, billingIntervalAsSuffix, EBillingInterval } from '@leedpulse-monorepo/enums';
import { IPlan } from '@leedpulse-monorepo/interfaces';

interface StepPlanProps {
  selectedPlan: string;
  onPlanChange: (value: string) => void;
  onAccountTypeChange: (value: AccountType) => void;
  stepTitle: string;
  plans: IPlan[];
  accountType: AccountType;
}

const StepPlan: React.FC<StepPlanProps> = ({ selectedPlan, onPlanChange, onAccountTypeChange, stepTitle, plans, accountType }) => {
  return (
    <div className="signup__step-content">
      <h2 className="signup__step-title">{stepTitle}</h2>
      <p className="signup__step-subtitle">Choisissez la formule d'abonnement</p>
      <Flex>
        <Form.Item label="Choisir un type de compte">
          <Radio.Group value={accountType} onChange={(e) => onAccountTypeChange(e.target.value as AccountType)} block optionType="button" buttonStyle='solid'>
            <Radio value={AccountType.COMPANY}>Je prendais un numéro plus tard</Radio>
            <Radio value={AccountType.SUBSCRIPTION}>Je veux un numéro professionnel</Radio>
          </Radio.Group>
        </Form.Item>
      </Flex>
      {accountType === AccountType.SUBSCRIPTION ? <Form.Item label="Formule d'abonnement" layout="vertical">
        <Flex gap="8px" vertical>
          {plans.map((plan) => (
            <button
              key={plan.id}
              type="button"
              className={`signup__plan-btn ${selectedPlan === plan.id ? 'signup__plan-btn--selected' : ''
                }`}
              onClick={() => onPlanChange(plan.id)}
            >
              <span className="signup__plan-name">{plan.name}</span>
              <span className="signup__plan-price">{plan.price?.formatted || '0€'}{billingIntervalAsSuffix(plan.price?.interval ?? EBillingInterval.MONTH)}</span>
              {selectedPlan === plan.id && <CheckOutlined className="signup__plan-check" />}
            </button>
          ))}
        </Flex>
      </Form.Item> :
        <Alert message="Vous pourrez choisir un plan et un numéro professionnel plus tard." type="info" />}
    </div>
  );
};

export default StepPlan;
